import { observer } from 'mobx-react-lite';
import { Segment } from 'semantic-ui-react';
import MyFolderFileList from '../../../app/common/folderfiles/MyFolderFileList';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';
import { useStore } from '../../../app/stores/store';
import { useEffect } from 'react';

export default observer(function ActivityDetailedInfo() {
  const {
    commonStore,
    viewStore: { getItemPageFilesStructure },
    activityStore: { selectedActivity: activity },
  } = useStore();

  useEffect(() => {
    getItemPageFilesStructure({ itemId: activity?.id });
    // eslint-disable-next-line
  }, [activity?.id]);
  return (
    <div
      className={
        commonStore.filterModeZero?.includes('AVLAVD03')
          ? 'component-isDisabled activityDetailedInfo'
          : 'activityDetailedInfo'
      }
    >
      <Segment
        className="segment-name-small"
        textAlign="center"
        style={{
          border: 'none',
          // width:"200px"
        }}
        attached="top"
        secondary
        inverted
        color="blue"
        //Assets
      >
        {
          (userLanguage[0].AssetsViewItemLevelViewPage?.AVILVPS01 as any)?.[
            `${commonStore.language.key}`
          ]
        }
      </Segment>
      <div className="folderlist-small">
        <Segment attached>
          <MyFolderFileList />
        </Segment>
      </div>
    </div>
  );
});
